import firebase from "firebase/app";

import { useOutletContext } from "react-router-dom";

import getDistributionChannelsQuery from "astrid-firestore/src/api/distribution/getDistributionChannelsQuery";
import useCollectionData from "astrid-firestore/src/hooks/useCollectionData";

import LoadingContext from "../../ui/components/LoadingContext/LoadingContext";

import ArticlesCalendarView from "../views/ArticlesCalendarView/ArticlesCalendarView";

export default function ArticlesCalendar() {
	const { data, organization } = useOutletContext();

	const [distributionChannels, loading, error] = useCollectionData(getDistributionChannelsQuery(firebase));

	return (
		<LoadingContext data={distributionChannels} loading={loading} error={error}>
			<ArticlesCalendarView organization={organization} data={data} distributionChannels={distributionChannels} />
		</LoadingContext>
	);
}
